module.exports = __webpack_public_path__ + "img/20200515_162918.9b2c216e.jpg";